import {useGetUserProfileQuery} from "../user/api/get_user_profile";
import {getShowPrice} from "../utils/get_show_price";
import {PriceVisibilityType} from "../vendor/types/PriceVisibilityType";
import {useHidePricesAbTest} from "./use_hide_prices_ab_test";

interface IUseShouldShowPriceParams {
    offerPriceVisibility?: PriceVisibilityType;
    vendorPriceVisibility?: PriceVisibilityType;
    vendorId: number;
}

/**
 * Hook that determines if price should be shown based on:
 * - Offer and vendor price visibility configuration
 * - Vendor exclusion list
 * - A/B test variant:
 *   - VISIBLE (0): Always show price (based on config)
 *   - HIDDEN (1): Hide price (blurred UI)
 *   - VISIBLE_WITH_COMPLETE_PROFILE (2): Show price (set server-side for authenticated users with complete profile)
 */
export const useShouldShowPrice = (params: IUseShouldShowPriceParams): boolean => {
    const {offerPriceVisibility = PriceVisibilityType.ALWAYS, vendorPriceVisibility = PriceVisibilityType.AUTO, vendorId} = params;
    const {isHiddenVariant} = useHidePricesAbTest();

    const {data: userInfo} = useGetUserProfileQuery();

    const shouldShowByConfig = getShowPrice({
        offerPriceVisibility,
        vendorPriceVisibility,
        vendorId
    });

    // Hide prices (blurred UI) for HIDDEN variant if user is not logged in or has incomplete profile
    if (isHiddenVariant && (!userInfo || (userInfo && !userInfo.phone))) {
        return false;
    }

    // VISIBLE, VISIBLE_WITH_COMPLETE_PROFILE: show based on config
    return shouldShowByConfig;
};
import {useGetUserProfileQuery} from "../user/api/get_user_profile";
import {getShowPrice} from "../utils/get_show_price";
import {PriceVisibilityType} from "../vendor/types/PriceVisibilityType";
import {useHidePricesAbTest} from "./use_hide_prices_ab_test";

interface IUseShouldShowPriceParams {
    offerPriceVisibility?: PriceVisibilityType;
    vendorPriceVisibility?: PriceVisibilityType;
    vendorId: number;
}

/**
 * Hook that determines if price should be shown based on:
 * - Offer and vendor price visibility configuration
 * - Vendor exclusion list
 * - A/B test variant:
 *   - VISIBLE (0): Always show price (based on config)
 *   - HIDDEN (1): Hide price (blurred UI)
 *   - VISIBLE_WITH_COMPLETE_PROFILE (2): Show price (set server-side for authenticated users with complete profile)
 */
export const useShouldShowPrice = (params: IUseShouldShowPriceParams): boolean => {
    const {offerPriceVisibility = PriceVisibilityType.ALWAYS, vendorPriceVisibility = PriceVisibilityType.AUTO, vendorId} = params;
    const {isHiddenVariant} = useHidePricesAbTest();

    const {data: userInfo} = useGetUserProfileQuery();

    const shouldShowByConfig = getShowPrice({
        offerPriceVisibility,
        vendorPriceVisibility,
        vendorId
    });

    // Hide prices (blurred UI) for HIDDEN variant if user is not logged in or has incomplete profile
    if (isHiddenVariant && (!userInfo || (userInfo && !userInfo.phone))) {
        return false;
    }

    // VISIBLE, VISIBLE_WITH_COMPLETE_PROFILE: show based on config
    return shouldShowByConfig;
};
